import { render, staticRenderFns } from "./FileIcon.vue?vue&type=template&id=0545c36a&"
import script from "./FileIcon.vue?vue&type=script&lang=ts&"
export * from "./FileIcon.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports